import { render, staticRenderFns } from "./update-pw-form.vue?vue&type=template&id=04faeb60&"
import script from "./update-pw-form.vue?vue&type=script&lang=js&"
export * from "./update-pw-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports